import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-document.png'


const _withScopeId = n => (_pushScopeId("data-v-c179e78e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "section-input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "문서 아이콘"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lastcall-text" }, "마지막 호출 내역", -1))
const _hoisted_5 = { class: "lastcall-time" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lastcall-explain-text" }, [
  /*#__PURE__*/_createTextVNode(" 가장 최근에 연결했던 호출내역입니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 재연결하시려면 직접 통화하기를 선택해주세요. ")
], -1))
const _hoisted_7 = { class: "bottom-btn-wrapper" }
const _hoisted_8 = { class: "two-btn-block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-pay" }, "5G, 3G, LTE 환경에서 데이터 요금이 발생됩니다.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_logo = _resolveComponent("header-logo")!
  const _component_board_marquee = _resolveComponent("board-marquee")!
  const _component_button_big = _resolveComponent("button-big")!
  const _component_button_icon = _resolveComponent("button-icon")!
  const _component_autocall_button_off = _resolveComponent("autocall-button-off")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_logo),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_board_marquee),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.lastcall), 1),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createVNode(_component_button_big, {
            command: "callDirect",
            disabled: true,
            title: "운전자 다이렉트 호출",
            subTitle: "오토콜이 운전자를 대신 호출합니다"
          }),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_button_icon, {
              disabled: true,
              command: "sendMessage",
              icon: "icon-message.png",
              text: "메시지 보내기",
              class: "btn-icon-radius left shadow"
            }),
            _createVNode(_component_button_icon, {
              command: "confirmCall",
              icon: "icon-phone.png",
              text: "직접 통화하기",
              class: "btn-icon-radius right shadow"
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _createVNode(_component_autocall_button_off)
        ])
      ])
    ])
  ], 64))
}